import { Box, Grid } from "@mui/material";
import styled from "styled-components";
import "moment/locale/nl";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropertyDetailsCarousel from "../components/PropertyDetails/PropertyDetailsCarousel";
import PropertyDetailsDescription from "../components/PropertyDetails/PropertyDetailsDescription";
import PropertyDetailsHeader from "../components/PropertyDetails/PropertyDetailsHeader";
import PropertyDetailsMap from "../components/PropertyDetails/PropertyDetailsMap";
import PropertyDetailsSpecifications from "../components/PropertyDetails/PropertyDetailsSpecifications";
import PropertyDetailsViewing from "../components/PropertyDetails/PropertyDetailsViewing";
import Wrapper from "../components/layout/Wrapper";
import { isMobile } from "react-device-detect";
import NAV from "../utils/nav.const";

type PropertyDetailsProps = {
  property: any;
  loadingProperty: boolean;
};

const PropertyDetails = ({
  property,
  loadingProperty,
}: PropertyDetailsProps) => {
  const [propertyFound, setPropertyFound] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loadingProperty && !property) {
      setPropertyFound(false);
    }
  }, [loadingProperty, property]);

  const scrollTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  useEffect(() => {
    scrollTop();
  }, []);

  useEffect(() => {
    if (!propertyFound) {
      navigate("/" + NAV.NO_MATCH);
    }
  }, [propertyFound]);

  return (
    <>
      <Wrapper>
        <Box>
          <Grid container spacing={3}>
            <Grid
              gap={2}
              display={"flex"}
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
              item
              xs={12}
              lg={12}
            >
              <PropertyDetailsHeader property={property} />
            </Grid>
            <Grid item xs={12} lg={8}>
              <BoxPaper>
                <PropertyDetailsCarousel
                  images={property?.propertyMedia?.propertyImages}
                  loading={loadingProperty}
                />
                <PropertyDetailsDescription property={property} />
              </BoxPaper>
              {isMobile && <PropertyDetailsViewing property={property} />}
              <PropertyDetailsSpecifications property={property} />
            </Grid>

            <Grid item xs={12} lg={4}>
              <PropertyDetailsMap property={property} />
              {!isMobile && <PropertyDetailsViewing property={property} />}
            </Grid>
          </Grid>
        </Box>
      </Wrapper>
    </>
  );
};

export default PropertyDetails;

export const ErrorContainer = styled("div")({
  backgroundColor: "#fff",
});

export const BoxPaper = styled("div")({
  boxShadow: "0 4px 4px 0 rgba(23, 23, 23, 0.06)",
  width: "100%",
  padding: "1rem 1rem",
  borderRadius: "1rem",
  border: "1px solid #eee",
  backgroundColor: "#fff",
});
